// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Zjyyn{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}.GRXIq{width:100%;max-width:700px;min-width:0;flex-shrink:1}.GcZzj{display:flex;align-items:center;gap:8px;width:100%;height:32px;padding:0 8px 0 12px;border:1px solid #9393b1;border-radius:999px;background-color:#fff}.GcZzj.HNYsq{border-color:#282863}.GcZzj.iQx2Z{border:1px solid transparent;background:linear-gradient(#ffffff, #ffffff) padding-box,linear-gradient(100deg, #2cf1ff 0%, #7856f9 45%, #ff5f8f 100%) border-box;background-size:100% 100%,200% 100%;animation:Zjyyn 1.5s ease-in-out infinite}.gPPo4{display:flex;align-items:center;flex-shrink:0;color:#9393b1}.GcZzj .gPPo4 [data-gradient-overlay]{animation:none}.z4LfU{position:relative;flex:1;min-width:0}.z4LfU.xuCP_ input{color:#9393b1}.oFBrA{flex:1 1 auto;width:100%;min-width:0}.oFBrA [data-testid\$=AnimatedPlaceholder]{left:0}.TXCRL{background-color:transparent !important}.TXCRL fieldset{border:none !important}.TXCRL input{padding-left:0}.luZu7{display:flex;align-items:center;flex-shrink:0}.iQx2Z .luZu7{opacity:.5}.FXoLm{display:flex;align-items:center;flex-shrink:0;background-color:#f4f4f7;border:1px solid #bfbfd0;border-radius:999px;padding:2px 8px;pointer-events:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple100": `#dad0fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"root": `GRXIq`,
	"pill": `GcZzj`,
	"filled": `HNYsq`,
	"processing": `iQx2Z`,
	"aiBorderShimmer": `Zjyyn`,
	"searchIcon": `gPPo4`,
	"field": `z4LfU`,
	"fieldMuted": `xuCP_`,
	"animatedField": `oFBrA`,
	"bareInput": `TXCRL`,
	"submitCue": `luZu7`,
	"filtersEditedBadge": `FXoLm`
};
export default ___CSS_LOADER_EXPORT___;
